export default "__VITE_ASSET__COQvq1GE__"